import * as React from "react";
import Helmet from "@/components/Helmet";
import { useTheme } from "@/hooks/useTheme";
import Old404Page from "@/components/pages/old/404";
import New404Page from "@/components/pages/new/404";
import SetupContract from "@/components/SetupContract";

const NotFoundPage = () => {
  const { isNewTheme } = useTheme();
  return (
    <SetupContract>
      <Helmet title="AI査定ツール | 404 Not Found." meta={[{ name: "robots", content: "noindex,nofollow" }]} />
      {isNewTheme === true ? <New404Page /> : <Old404Page />}
    </SetupContract>
  );
};

export default NotFoundPage;
